import React, { useState, useRef, useEffect, useMemo } from "react";
import WindowHeader from "./Layout/WindowHeader/WindowHeader";
import headeLogo from "../assets/images/shersoftnavLogo.png";
import { useDbContext } from "../context/DbContext";
import axios from "axios";
import { ClipLoader } from "react-spinners";
import { useSelector } from "react-redux";
import { selectActiveLocation } from "../app/locationSlice";
import useInfiniteTable from "./shared/useInfiniteTable";
import {
  FiSend,
  FiSave,
  FiRefreshCw,
  FiTrash2,
  FiPlus,
  FiSearch,
  FiPaperclip,
  FiFileText,
  FiUser,
  FiShield,
  FiMapPin,
  FiLayers,
  FiSliders,
} from "react-icons/fi";
import { FaWhatsapp, FaCheckDouble, FaFilePdf } from "react-icons/fa";

// Available dynamic variable tokens palette
const VARIABLES = [
  {
    key: "customerName",
    label: "Name",
    badgeBg: "bg-indigo-100 text-indigo-700 border-indigo-200",
    btnBg: "bg-indigo-50 hover:bg-indigo-100 border-indigo-200 text-indigo-800",
  },
  {
    key: "accountNo",
    label: "A/C No",
    badgeBg: "bg-blue-100 text-blue-700 border-blue-200",
    btnBg: "bg-blue-50 hover:bg-blue-100 border-blue-200 text-blue-800",
  },
  {
    key: "total",
    label: "Amount",
    badgeBg: "bg-amber-100 text-amber-800 border-amber-300",
    btnBg: "bg-amber-50 hover:bg-amber-100 border-amber-300 text-amber-900",
  },
  {
    key: "grandTotal",
    label: "Grand Total",
    badgeBg: "bg-emerald-100 text-emerald-700 border-emerald-200",
    btnBg: "bg-emerald-50 hover:bg-emerald-100 border-emerald-200 text-emerald-800",
  },
  {
    key: "openingBalance",
    label: "Opening Bal",
    badgeBg: "bg-purple-100 text-purple-700 border-purple-200",
    btnBg: "bg-purple-50 hover:bg-purple-100 border-purple-200 text-purple-800",
  },
  {
    key: "gm",
    label: "Gold Grams",
    badgeBg: "bg-yellow-100 text-yellow-800 border-yellow-300",
    btnBg: "bg-yellow-50 hover:bg-yellow-100 border-yellow-300 text-yellow-900",
  },
  {
    key: "netwt",
    label: "Net Weight",
    badgeBg: "bg-pink-100 text-pink-700 border-pink-200",
    btnBg: "bg-pink-50 hover:bg-pink-100 border-pink-200 text-pink-800",
  },
  {
    key: "mobileNo",
    label: "Mobile",
    badgeBg: "bg-cyan-100 text-cyan-700 border-cyan-200",
    btnBg: "bg-cyan-50 hover:bg-cyan-100 border-cyan-200 text-cyan-800",
  },
  {
    key: "showroomName",
    label: "Showroom",
    badgeBg: "bg-slate-200 text-slate-700 border-slate-300",
    btnBg: "bg-slate-100 hover:bg-slate-200 border-slate-300 text-slate-800",
  },
  {
    key: "date",
    label: "Date",
    badgeBg: "bg-slate-200 text-slate-700 border-slate-300",
    btnBg: "bg-slate-100 hover:bg-slate-200 border-slate-300 text-slate-800",
  },
];

// Sample mock recipients for live WhatsApp simulator (strictly dummy data)
const SAMPLE_MOCKS = [
  {
    name: "Customer A",
    accountNo: "ACC-1001",
    customerName: "Customer A",
    total: "5,000",
    grandTotal: "50,000",
    openingBalance: "10,000",
    gm: "5.000",
    netwt: "0.500",
    mobileNo: "919800000001",
    showroomName: "Showroom",
    date: "01/Jan/2026",
  },
  {
    name: "Customer B",
    accountNo: "ACC-1002",
    customerName: "Customer B",
    total: "12,500",
    grandTotal: "1,20,000",
    openingBalance: "35,000",
    gm: "12.500",
    netwt: "1.200",
    mobileNo: "919800000002",
    showroomName: "Showroom",
    date: "01/Jan/2026",
  },
  {
    name: "Customer C",
    accountNo: "ACC-1003",
    customerName: "Customer C",
    total: "25,000",
    grandTotal: "2,50,000",
    openingBalance: "75,000",
    gm: "25.000",
    netwt: "2.400",
    mobileNo: "919800000003",
    showroomName: "Showroom",
    date: "01/Jan/2026",
  },
];

// Standard dummy recipients list for testing
const DEFAULT_DUMMY_RECIPIENTS = [
  { CustomerName: "Sample Customer 1", mobileNo: "919800000001" },
  { CustomerName: "Sample Customer 2", mobileNo: "919800000002" },
  { CustomerName: "Sample Customer 3", mobileNo: "919800000003" },
  { CustomerName: "Sample Customer 4", mobileNo: "919800000004" },
];

// Clean phone number ensuring proper 10-12 digit standard without + or spaces
const sanitizePhoneNumber = (num) => {
  if (!num) return "";
  let digits = String(num).replace(/\D/g, "");
  if (digits.length === 10) {
    digits = "91" + digits;
  }
  return digits;
};

function WhatsAppSettings({ onClose, zIndex }) {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const activeLocation = useSelector(selectActiveLocation);
  const { dbCode } = useDbContext();

  // Active WhatsApp API Provider: "rapiwha" | "greenads"
  const [selectedProvider, setSelectedProvider] = useState("rapiwha");

  // Right-hand panel active tab: "preview" (Live Chat Simulator) | "recipients" (Recipient Table)
  const [activeRightTab, setActiveRightTab] = useState("preview");

  // Mock recipient selected for simulator
  const [mockIndex, setMockIndex] = useState(0);

  // Settings State for common fields (starts empty, displaying informative placeholders)
  const [WhatsAppsettingsData, setWhatsAppsettingsData] = useState({
    EntryName: "SCHEME RECEIPT",
    Message: "",
    appkey: "",
    authkey: "",
    senderNo: "",
    Media: null,
  });

  // GreenAds (Telinfy Hub) specific configuration (starts empty, displaying informative placeholders)
  const [greenAdsConfig, setGreenAdsConfig] = useState({
    apiKey: "",
    templateName: "",
    language: "en",
    documentFilename: "",
    message: "",
    param1: "${customerName}",
    param2: "${total}",
    param3: "${openingBalance}",
    param4: "${grandTotal}",
    param5: "${showroomName}",
  });

  // Recipients list (loads real customer records from database)
  const [tableData, setTableData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);

  // Add new recipient form
  const [newRow, setNewRow] = useState({
    CustomerName: "",
    mobileNo: "",
  });

  // Dispatch & Cancellation Progress
  const [sendProgress, setSendProgress] = useState({
    sending: false,
    sent: 0,
    total: 0,
    cancelled: false,
    currentName: "",
  });

  const cancelTokenRef = useRef(null);
  const textareaRef = useRef(null);
  const fileInputRef = useRef(null);

  // Common default voucher types
  const defaultVoucherOptions = [
    "SCHEME RECEIPT",
    "RECEIPT",
    "SALES",
    "ESTIMATE",
    "OLD GOLD",
    "CASH RECEIPT",
    "PAYMENT",
    "DUE REMINDER",
  ];

  // Registered WhatsApp templates from database
  const [registeredTemplates, setRegisteredTemplates] = useState([]);

  // Fetch all registered WhatsApp templates from database
  const fetchRegisteredTemplates = async () => {
    if (!dbCode) return;
    try {
      const res = await axios.get(
        `${apiBaseUrl}/main/selectAllWhatsAppSettings/${dbCode}`
      );
      if (Array.isArray(res.data)) {
        setRegisteredTemplates(res.data);
      }
    } catch (err) {
      // ignore
    }
  };

  const allVoucherSuggestions = useMemo(() => {
    const list = [...defaultVoucherOptions];
    registeredTemplates.forEach((t) => {
      if (t.Voucher && !list.includes(t.Voucher)) {
        list.push(t.Voucher);
      }
    });
    return list;
  }, [registeredTemplates]);

  // Click "+ New Voucher" to create a new template / voucher type
  const handleCreateNewVoucher = () => {
    setWhatsAppsettingsData((prev) => ({
      ...prev,
      EntryName: "",
      Message: "",
      Media: null,
    }));
    setGreenAdsConfig((prev) => ({
      ...prev,
      templateName: "",
      message: "",
      documentFilename: "",
    }));
    setTimeout(() => {
      document.getElementById("entry-name-input")?.focus();
    }, 50);
  };

  // Fetch real customer contacts from database
  const fetchNumbers = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `${apiBaseUrl}/main/selectAllschemeData/${dbCode}`
      );
      if (Array.isArray(response.data)) {
        setTableData(response.data);
      } else {
        setTableData([]);
      }
    } catch (error) {
      console.error("Error fetching recipient numbers from database:", error);
      setTableData([]);
    } finally {
      setIsLoading(false);
    }
  };

  // Fetch saved settings for a specific voucher
  const fetchWhatsAppsettings = async (eName) => {
    if (!eName) return;
    try {
      const localKey = `whatsapp_gateway_config_${dbCode}_${eName}`;
      let localSaved = null;
      try {
        const stored = localStorage.getItem(localKey);
        if (stored) localSaved = JSON.parse(stored);
      } catch (err) {
        // ignore parse error
      }

      const response = await axios.get(
        `${apiBaseUrl}/main/selectwhtAppapidatas/${dbCode}/${eName}?locationId=${
          activeLocation ? activeLocation.id : ""
        }`
      );
      const whtAppstngsData = response.data?.[0];

      if (whtAppstngsData) {
        const authKeyVal = whtAppstngsData.Authkey || "";
        const isGreenAdsSaved =
          authKeyVal.startsWith("greenads") || localSaved?.provider === "greenads";

        if (isGreenAdsSaved) {
          setSelectedProvider("greenads");
          const extractedTemplate = authKeyVal.includes(":")
            ? authKeyVal.split(":")[1]
            : whtAppstngsData.SenderNumber || "";

          setGreenAdsConfig({
            apiKey: whtAppstngsData.appKey || localSaved?.greenads?.apiKey || "",
            templateName: extractedTemplate || localSaved?.greenads?.templateName || "",
            language: localSaved?.greenads?.language || "en",
            documentFilename: localSaved?.greenads?.documentFilename || "",
            message: whtAppstngsData.MessageBody || localSaved?.greenads?.message || "",
            param1: localSaved?.greenads?.param1 || "${customerName}",
            param2: localSaved?.greenads?.param2 || "${total}",
            param3: localSaved?.greenads?.param3 || "${openingBalance}",
            param4: localSaved?.greenads?.param4 || "${grandTotal}",
            param5: localSaved?.greenads?.param5 || "${showroomName}",
          });

          // Restore Rapiwha from cache if previously configured for this voucher, or reset empty
          setWhatsAppsettingsData((prev) => ({
            ...prev,
            EntryName: whtAppstngsData.Voucher || eName,
            appkey: localSaved?.rapiwha?.appkey || "",
            senderNo: localSaved?.rapiwha?.senderNo || "",
            authkey: localSaved?.rapiwha?.authkey || "",
            Message: localSaved?.rapiwha?.message || "",
          }));
        } else {
          setSelectedProvider("rapiwha");

          setWhatsAppsettingsData((prev) => ({
            ...prev,
            EntryName: whtAppstngsData.Voucher || eName,
            appkey: whtAppstngsData.appKey || "",
            senderNo: whtAppstngsData.SenderNumber || "",
            authkey: whtAppstngsData.Authkey || "",
            Message: whtAppstngsData.MessageBody || "",
          }));

          // Restore GreenAds from cache if previously configured for this voucher, or reset empty
          setGreenAdsConfig({
            apiKey: localSaved?.greenads?.apiKey || "",
            templateName: localSaved?.greenads?.templateName || "",
            language: localSaved?.greenads?.language || "en",
            documentFilename: localSaved?.greenads?.documentFilename || "",
            message: localSaved?.greenads?.message || "",
            param1: localSaved?.greenads?.param1 || "${customerName}",
            param2: localSaved?.greenads?.param2 || "${total}",
            param3: localSaved?.greenads?.param3 || "${openingBalance}",
            param4: localSaved?.greenads?.param4 || "${grandTotal}",
            param5: localSaved?.greenads?.param5 || "${showroomName}",
          });
        }
      } else {
        // No DB record found for this voucher: check local cache or reset completely
        if (localSaved) {
          if (localSaved.provider) setSelectedProvider(localSaved.provider);
          setWhatsAppsettingsData((prev) => ({
            ...prev,
            EntryName: eName,
            appkey: localSaved.rapiwha?.appkey || "",
            senderNo: localSaved.rapiwha?.senderNo || "",
            authkey: localSaved.rapiwha?.authkey || "",
            Message: localSaved.rapiwha?.message || "",
          }));
          setGreenAdsConfig({
            apiKey: localSaved.greenads?.apiKey || "",
            templateName: localSaved.greenads?.templateName || "",
            language: localSaved.greenads?.language || "en",
            documentFilename: localSaved.greenads?.documentFilename || "",
            message: localSaved.greenads?.message || "",
            param1: localSaved.greenads?.param1 || "${customerName}",
            param2: localSaved.greenads?.param2 || "${total}",
            param3: localSaved.greenads?.param3 || "${openingBalance}",
            param4: localSaved.greenads?.param4 || "${grandTotal}",
            param5: localSaved.greenads?.param5 || "${showroomName}",
          });
        } else {
          // Complete fresh reset for voucher with no saved configuration
          setWhatsAppsettingsData((prev) => ({
            ...prev,
            EntryName: eName,
            appkey: "",
            senderNo: "",
            authkey: "",
            Message: "",
            Media: null,
          }));
          setGreenAdsConfig({
            apiKey: "",
            templateName: "",
            language: "en",
            documentFilename: "",
            message: "",
            param1: "${customerName}",
            param2: "${total}",
            param3: "${openingBalance}",
            param4: "${grandTotal}",
            param5: "${showroomName}",
          });
        }
      }
    } catch (error) {
      console.error("Error fetching WhatsApp settings:", error);
    }
  };

  useEffect(() => {
    fetchNumbers();
    fetchRegisteredTemplates();
    fetchWhatsAppsettings(WhatsAppsettingsData.EntryName);
  }, [apiBaseUrl, dbCode]);

  // Insert token chip into textarea at current cursor position
  const handleInsertToken = (tokenKey) => {
    const token = `\${${tokenKey}}`;
    const textarea = textareaRef.current;
    const currentVal =
      selectedProvider === "greenads"
        ? greenAdsConfig.message || ""
        : WhatsAppsettingsData.Message || "";

    if (!textarea) {
      if (selectedProvider === "greenads") {
        setGreenAdsConfig((prev) => ({
          ...prev,
          message: (prev.message || "") + token,
        }));
      } else {
        setWhatsAppsettingsData((prev) => ({
          ...prev,
          Message: (prev.Message || "") + token,
        }));
      }
      return;
    }

    const start = textarea.selectionStart || 0;
    const end = textarea.selectionEnd || 0;
    const updated =
      currentVal.substring(0, start) + token + currentVal.substring(end);

    if (selectedProvider === "greenads") {
      setGreenAdsConfig((prev) => ({ ...prev, message: updated }));
    } else {
      setWhatsAppsettingsData((prev) => ({ ...prev, Message: updated }));
    }

    setTimeout(() => {
      textarea.focus();
      textarea.setSelectionRange(start + token.length, start + token.length);
    }, 50);
  };

  // Keyboard shortcut listener
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        e.preventDefault();
        onClose();
      } else if (e.key === "F2") {
        e.preventDefault();
        handleSave();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [WhatsAppsettingsData, greenAdsConfig, selectedProvider]);

  // Clear form inputs
  const handleClear = () => {
    setWhatsAppsettingsData({
      EntryName: "SCHEME RECEIPT",
      Message: "",
      appkey: "",
      authkey: "",
      senderNo: "",
      Media: null,
    });
    setGreenAdsConfig({
      apiKey: "",
      templateName: "",
      language: "en",
      documentFilename: "",
      message: "",
      param1: "${customerName}",
      param2: "${total}",
      param3: "${openingBalance}",
      param4: "${grandTotal}",
      param5: "${showroomName}",
    });
    setTableData(DEFAULT_DUMMY_RECIPIENTS);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  // Add new recipient row to table
  const addRow = () => {
    if (!newRow.CustomerName.trim() || !newRow.mobileNo.trim()) {
      alert("Please enter both Customer Name and Mobile Number.");
      return;
    }

    setTableData((prev) => [{ ...newRow }, ...prev]);
    setNewRow({ CustomerName: "", mobileNo: "" });
  };

  // Remove recipient row or clear all
  const removeRow = (target) => {
    if (!target) {
      if (tableData.length === 0) {
        alert("No recipients to remove.");
        return;
      }
      if (
        window.confirm(
          `Are you sure you want to remove all ${tableData.length} recipients?`
        )
      ) {
        setTableData([]);
      }
    } else {
      setTableData((prev) => prev.filter((r) => r !== target));
    }
  };

  // Save WhatsApp settings
  const handleSave = async () => {
    const voucherName = WhatsAppsettingsData.EntryName?.trim();
    if (!voucherName) {
      alert("Please select or enter a Voucher / Scheme Entry Name.");
      return;
    }

    if (selectedProvider === "rapiwha") {
      if (!WhatsAppsettingsData.appkey.trim()) {
        alert("Please enter the Rapiwha App Key.");
        return;
      }
      if (!WhatsAppsettingsData.Message.trim()) {
        alert("Please enter the Message Template.");
        return;
      }
    } else if (selectedProvider === "greenads") {
      if (!greenAdsConfig.apiKey.trim()) {
        alert("Please enter the GreenAds / Telinfy API Key (x-api-key).");
        return;
      }
      if (!greenAdsConfig.templateName.trim()) {
        alert("Please enter the Meta registered Template Name for GreenAds.");
        return;
      }
    }

    try {
      setIsSaving(true);

      const effectiveAppKey =
        selectedProvider === "greenads"
          ? greenAdsConfig.apiKey
          : WhatsAppsettingsData.appkey;

      const effectiveAuthKey =
        selectedProvider === "greenads"
          ? `greenads:${greenAdsConfig.templateName}`
          : WhatsAppsettingsData.authkey || "";

      const effectiveSenderNo =
        selectedProvider === "greenads"
          ? greenAdsConfig.templateName
          : WhatsAppsettingsData.senderNo || "";

      const effectiveMessage =
        selectedProvider === "greenads"
          ? greenAdsConfig.message || ""
          : WhatsAppsettingsData.Message;

      const payload = {
        EntryName: voucherName,
        Message: effectiveMessage,
        appkey: effectiveAppKey,
        authkey: effectiveAuthKey,
        senderNo: effectiveSenderNo,
        Location: activeLocation ? activeLocation.id : null,
      };

      const response = await axios.post(
        `${apiBaseUrl}/main/whatsAppsettings/${dbCode}`,
        payload
      );

      const localKey = `whatsapp_gateway_config_${dbCode}_${voucherName}`;
      localStorage.setItem(
        localKey,
        JSON.stringify({
          provider: selectedProvider,
          apiKey: effectiveAppKey,
          rapiwha: {
            appkey: WhatsAppsettingsData.appkey,
            senderNo: WhatsAppsettingsData.senderNo,
            authkey: WhatsAppsettingsData.authkey,
            message: WhatsAppsettingsData.Message,
          },
          greenads: {
            ...greenAdsConfig,
          },
        })
      );

      if (response.status === 200 || response.data?.success) {
        await fetchRegisteredTemplates();
        alert(
          `WhatsApp settings for "${voucherName}" saved successfully using ${
            selectedProvider === "greenads" ? "GreenAds Telinfy" : "Rapiwha"
          } gateway!`
        );
      } else {
        alert("Failed to save WhatsApp settings: " + (response.data?.message || "Unknown error"));
      }
    } catch (error) {
      console.error("Error saving WhatsApp settings:", error);
      alert(
        "Error saving settings: " +
          (error.response?.data?.message || error.message)
      );
    } finally {
      setIsSaving(false);
    }
  };

  // Cancel bulk sending
  const handleCancelSend = () => {
    if (cancelTokenRef.current) {
      cancelTokenRef.current.cancel("Sending cancelled by user");
    }
    setSendProgress((prev) => ({ ...prev, cancelled: true, sending: false }));
  };

  // Helper: Dispatch via Rapiwha HTTP Gateway
  const sendRapiwhaMessage = async (phoneNumber, appkey, text, mediaUrl = null) => {
    const cleanNumber = sanitizePhoneNumber(phoneNumber);
    let apiUrl = `https://panel.rapiwha.com/send_message.php?apikey=${appkey}&number=${cleanNumber}`;

    if (mediaUrl) {
      apiUrl += `&text=${encodeURIComponent(mediaUrl)}`;
    } else {
      apiUrl += `&text=${encodeURIComponent(text)}`;
    }

    const response = await axios.get(apiUrl, {
      cancelToken: cancelTokenRef.current?.token,
    });

    if (response.data && response.data.result_code === 0) {
      return { success: true, data: response.data };
    } else {
      throw new Error(response.data?.description || "Rapiwha gateway returned error");
    }
  };

  // Helper: Dispatch via GreenAds Global (Telinfy Hub WhatsApp Cloud API)
  const sendGreenAdsMessage = async ({
    phoneNumber,
    apiKey,
    templateName,
    pdfUrl = "",
    documentFilename = "Document.pdf",
    bodyParams = [],
  }) => {
    const cleanNumber = sanitizePhoneNumber(phoneNumber);
    const endpoint =
      "https://hub.telinfy.com/unified/developer/api/v1/whatsapp/campaigns/send";

    const components = [];

    if (pdfUrl && pdfUrl.trim() !== "") {
      components.push({
        type: "header",
        parameters: [
          {
            type: "document",
            document: {
              link: pdfUrl.trim(),
              filename: documentFilename || "Document.pdf",
            },
          },
        ],
      });
    }

    components.push({
      type: "body",
      parameters: bodyParams.map((val) => ({
        type: "text",
        text: String(val !== undefined && val !== null ? val : ""),
      })),
    });

    const requestPayload = {
      phoneNumber: cleanNumber,
      template: {
        name: templateName.trim(),
        language: { code: greenAdsConfig.language || "en" },
        components: components,
      },
    };

    const response = await axios.post(endpoint, requestPayload, {
      headers: {
        "x-api-key": apiKey.trim(),
        "Content-Type": "application/json",
      },
      cancelToken: cancelTokenRef.current?.token,
    });

    if (
      response.status === 200 ||
      response.status === 201 ||
      response.data?.status === "success" ||
      response.data?.success
    ) {
      return { success: true, data: response.data };
    } else {
      throw new Error(
        response.data?.message || "GreenAds campaign dispatch returned failure"
      );
    }
  };

  // Resolve template text replacing variables with mock or row object
  const resolveTemplateText = (template, dataObj) => {
    if (!template) return "";
    let res = template;
    const context = {
      customerName: dataObj?.CustomerName || dataObj?.customerName || "Customer Name",
      accountNo: dataObj?.accountNo || dataObj?.AccountNo || "ACC-1001",
      total: dataObj?.total || dataObj?.Total || "5,000",
      grandTotal: dataObj?.grandTotal || dataObj?.GrandTotal || "50,000",
      openingBalance: dataObj?.openingBalance || dataObj?.OpeningBalance || "0.00",
      gm: dataObj?.gm || dataObj?.Grams || "5.000",
      netwt: dataObj?.netwt || dataObj?.NetWeight || "0.500",
      mobileNo: dataObj?.mobileNo || dataObj?.MobileNo || "919800000000",
      showroomName:
        dataObj?.showroomName ||
        activeLocation?.LocationName ||
        "Showroom",
      date: new Date().toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      }),
    };

    Object.entries(context).forEach(([k, v]) => {
      res = res.replace(new RegExp(`\\$\\{${k}\\}`, "g"), v);
    });
    return res;
  };

  // Helper to extract the 5 positional parameters for GreenAds
  const getGreenAdsBodyParams = (rowData) => {
    const activeMock = {
      ...SAMPLE_MOCKS[mockIndex],
      ...(rowData || {}),
      customerName:
        rowData?.CustomerName ||
        rowData?.customerName ||
        SAMPLE_MOCKS[mockIndex].customerName,
      mobileNo: rowData?.mobileNo || SAMPLE_MOCKS[mockIndex].mobileNo,
      showroomName:
        activeLocation?.LocationName ||
        SAMPLE_MOCKS[mockIndex].showroomName,
    };

    const resolveField = (templateStr) =>
      resolveTemplateText(templateStr, activeMock);

    return [
      resolveField(greenAdsConfig.param1),
      resolveField(greenAdsConfig.param2),
      resolveField(greenAdsConfig.param3),
      resolveField(greenAdsConfig.param4),
      resolveField(greenAdsConfig.param5),
    ];
  };

  // Upload Media / Document to CDN
  const uploadAttachment = async () => {
    if (!WhatsAppsettingsData.Media) return null;

    try {
      const originalFile = WhatsAppsettingsData.Media;
      const cleanFileName = originalFile.name.replace(/\s+/g, "_");
      const modifiedFile = new File([originalFile], cleanFileName, {
        type: originalFile.type,
      });

      const formData = new FormData();
      formData.append("id", "erpMedia");
      formData.append("file", modifiedFile);

      const uploadResponse = await axios.post(
        "https://imageupload.shersoft.tech/upload",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
          cancelToken: cancelTokenRef.current?.token,
        }
      );

      if (uploadResponse.status === 200) {
        return `https://imageupload.shersoft.tech/image/erpMedia/${cleanFileName}`;
      }
    } catch (err) {
      console.error("Media upload error:", err);
    }
    return null;
  };

  // Broadcast or single test send handler
  const handleSend = async (singleRecipient = null) => {
    if (selectedProvider === "rapiwha") {
      if (!WhatsAppsettingsData.appkey?.trim()) {
        alert("Please enter the Rapiwha App Key in settings.");
        return;
      }
      if (!WhatsAppsettingsData.Message?.trim()) {
        alert("Please enter the message body.");
        return;
      }
    } else if (selectedProvider === "greenads") {
      if (!greenAdsConfig.apiKey?.trim()) {
        alert("Please enter the GreenAds / Telinfy API Key (x-api-key).");
        return;
      }
      if (!greenAdsConfig.templateName?.trim()) {
        alert("Please enter the Meta registered Template Name for GreenAds.");
        return;
      }
    }

    const recipientsToProcess = singleRecipient
      ? [singleRecipient]
      : tableData;

    if (recipientsToProcess.length === 0) {
      alert("No recipient numbers available to send. Please add contacts.");
      return;
    }

    cancelTokenRef.current = axios.CancelToken.source();
    setSendProgress({
      sending: true,
      sent: 0,
      total: recipientsToProcess.length,
      cancelled: false,
      currentName: "",
    });

    let mediaFileUrl = null;
    if (WhatsAppsettingsData.Media) {
      mediaFileUrl = await uploadAttachment();
      if (!mediaFileUrl) {
        const proceed = window.confirm(
          "Media upload failed. Do you want to proceed sending messages without the attachment?"
        );
        if (!proceed) {
          setSendProgress({ sending: false, sent: 0, total: 0, cancelled: false, currentName: "" });
          return;
        }
      }
    }

    let sentCount = 0;
    const failedList = [];

    for (let i = 0; i < recipientsToProcess.length; i++) {
      if (sendProgress.cancelled) break;

      const recipient = recipientsToProcess[i];
      const phone = recipient.mobileNo;
      const cName = recipient.CustomerName || "Customer";

      setSendProgress((p) => ({
        ...p,
        currentName: `${cName} (${phone})`,
      }));

      try {
        if (selectedProvider === "rapiwha") {
          const renderedText = resolveTemplateText(
            WhatsAppsettingsData.Message,
            recipient
          );

          if (mediaFileUrl && renderedText) {
            await sendRapiwhaMessage(phone, WhatsAppsettingsData.appkey, mediaFileUrl);
            await sendRapiwhaMessage(phone, WhatsAppsettingsData.appkey, renderedText);
          } else if (mediaFileUrl) {
            await sendRapiwhaMessage(phone, WhatsAppsettingsData.appkey, mediaFileUrl);
          } else {
            await sendRapiwhaMessage(phone, WhatsAppsettingsData.appkey, renderedText);
          }
          sentCount++;
        } else if (selectedProvider === "greenads") {
          const bodyParams = getGreenAdsBodyParams(recipient);
          await sendGreenAdsMessage({
            phoneNumber: phone,
            apiKey: greenAdsConfig.apiKey,
            templateName: greenAdsConfig.templateName,
            pdfUrl: mediaFileUrl || "",
            documentFilename:
              greenAdsConfig.documentFilename ||
              WhatsAppsettingsData.Media?.name ||
              "Document.pdf",
            bodyParams,
          });
          sentCount++;
        }
      } catch (error) {
        if (axios.isCancel(error)) {
          break;
        } else {
          console.error(`Failed to send to ${phone}:`, error);
          failedList.push(`${cName} (${phone}): ${error.message}`);
        }
      } finally {
        const currentProcessed = sentCount + failedList.length;
        setSendProgress((p) => ({
          ...p,
          sent: currentProcessed,
        }));
      }
    }

    cancelTokenRef.current = null;
    setSendProgress({
      sending: false,
      sent: 0,
      total: 0,
      cancelled: false,
      currentName: "",
    });

    let resultMsg = `Dispatch Finished via ${
      selectedProvider === "greenads" ? "GreenAds Telinfy" : "Rapiwha"
    }!\nSuccessfully Sent: ${sentCount} of ${recipientsToProcess.length}`;
    if (failedList.length > 0) {
      resultMsg += `\n\nFailed (${failedList.length}):\n` + failedList.slice(0, 5).join("\n");
      if (failedList.length > 5) {
        resultMsg += `\n...and ${failedList.length - 5} more.`;
      }
    }
    alert(resultMsg);
  };

  const filteredRecipients = useMemo(() => {
    if (!searchQuery) return tableData;
    const q = searchQuery.toLowerCase();
    return tableData.filter((item) => {
      const nameMatch = item.CustomerName?.toLowerCase().includes(q);
      const phoneMatch = item.mobileNo?.includes(q);
      return nameMatch || phoneMatch;
    });
  }, [tableData, searchQuery]);

  // Infinite continuous scrolling table hook for large recipient lists
  const {
    displayedRows: displayedRecipients,
    visibleCount,
    tableContainerRef,
    handleScroll,
    handleKeyDown: handleTableKeyDown,
    loadAll,
    hasMore,
  } = useInfiniteTable({
    items: filteredRecipients,
    initialCount: 50,
    step: 50,
  });

  const SAMPLE_RAPIWHA_PLACEHOLDER =
    "Dear ${customerName}, your transaction of ₹${total} towards A/C ${accountNo} has been processed successfully. - ${showroomName}";

  const SAMPLE_GREENADS_PLACEHOLDER =
    "Dear ${customerName},\nYour payment of ₹${total} has been confirmed.\nOpening Balance: ₹${openingBalance}\nTotal Outstanding: ₹${grandTotal}\n\nThank you,\n${showroomName}";

  const activeMockData = SAMPLE_MOCKS[mockIndex] || SAMPLE_MOCKS[0];

  const activeSimulatorMessage = useMemo(() => {
    if (selectedProvider === "greenads") {
      const template =
        greenAdsConfig.message?.trim() || SAMPLE_GREENADS_PLACEHOLDER;
      return resolveTemplateText(template, activeMockData);
    } else {
      const template =
        WhatsAppsettingsData.Message?.trim() || SAMPLE_RAPIWHA_PLACEHOLDER;
      return resolveTemplateText(template, activeMockData);
    }
  }, [
    selectedProvider,
    greenAdsConfig.message,
    WhatsAppsettingsData.Message,
    activeMockData,
  ]);

  return (
    <div
      className="absolute inset-0 w-full h-full bg-[#f0f0f0]/60 flex items-center justify-center pointer-events-auto select-none font-Inter [&_*]:!font-Inter overflow-hidden"
      style={{ zIndex: zIndex || 105 }}
    >
      {/* ── Main Modal Container ── */}
      <div className="bg-white font-Inter w-[98%] max-w-[1340px] h-[95%] max-h-[700px] border border-slate-200 shadow-md rounded-lg flex flex-col overflow-hidden absolute">
        {/* ── 1. Window Header ── */}
        <WindowHeader
          title="WhatsApp Gateway & Cloud API Master"
          logo={headeLogo}
          onClose={onClose}
          className="bg-[#0f2d59] text-white h-9 px-3 shrink-0"
          closeBtnClassName="h-6 w-6 my-auto mr-1 bg-red-600 hover:bg-red-700 rounded-sm border-none flex items-center justify-center text-white"
        />

        {/* ── 2. Top Action & Info Bar ── */}
        <section className="bg-white px-3 py-1.5 border-b border-slate-200 flex flex-wrap items-center justify-between gap-2 shrink-0 shadow-2xs">
          {/* Left Gateway Identity */}
          <div className="flex items-center space-x-2.5">
            <div className="w-7 h-7 rounded-lg bg-emerald-600 flex items-center justify-center text-white shadow-xs">
              <FaWhatsapp className="w-4 h-4" />
            </div>
            <div>
              <div className="flex items-center space-x-1.5">
                <h1 className="text-xs sm:text-sm font-bold text-slate-900 tracking-tight leading-none">
                  WhatsApp Gateway Manager
                </h1>
                <span className="text-[9px] font-bold bg-emerald-50 text-emerald-700 border border-emerald-200 px-1 py-0.2 rounded tracking-wide">
                  BUSINESS API
                </span>
                <span className="text-[9px] font-bold bg-blue-50 text-blue-700 border border-blue-200 px-1 py-0.2 rounded">
                  GATEWAY STUDIO
                </span>
              </div>
              <p className="text-[10px] text-slate-500 leading-tight mt-0.5 hidden sm:block">
                Multi-provider transactional WhatsApp messaging, PDF digital receipts &amp; Meta Cloud API.
              </p>
            </div>
          </div>

          {/* Right Status Badges */}
          <div className="flex items-center space-x-1.5 text-xs">
            {/* Location / Branch Badge */}
            <div className="flex items-center h-6.5 bg-slate-50 border border-slate-300 rounded px-2 text-slate-700 shadow-2xs">
              <FiMapPin className="text-amber-500 mr-1 text-[11px] shrink-0" />
              <span className="text-slate-500 text-[9px] font-semibold mr-1">BRANCH:</span>
              <span className="font-bold text-slate-800 text-[11px]">
                {activeLocation?.LocationName || activeLocation?.name || "Main Branch"}
              </span>
            </div>

            {/* Provider Pill Status */}
            <div className="flex items-center h-6.5 px-2 bg-emerald-50 border border-emerald-300 rounded text-emerald-700 font-bold text-[10px] space-x-1 shadow-2xs">
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse" />
              <span>
                {selectedProvider === "greenads" ? "GREENADS TELINFY" : "RAPHIWA GATEWAY"}
              </span>
            </div>

            {/* Recipients Count Pill */}
            <div className="flex items-center h-6.5 px-2 bg-blue-50 border border-blue-200 rounded text-blue-800 font-semibold text-[10px] shadow-2xs">
              <FiUser className="mr-1 text-blue-600 text-[11px]" />
              <span>{tableData.length} Test Contacts</span>
            </div>
          </div>
        </section>

        {/* ── 3. Compact Provider Selector Bar ── */}
        <section className="bg-slate-50 px-3 py-1 border-b border-slate-200 flex flex-wrap items-center justify-between gap-1.5 shrink-0">
          <div className="flex items-center space-x-1.5">
            <span className="text-[11px] font-bold text-slate-700 uppercase tracking-wider flex items-center gap-1">
              <FiLayers className="text-blue-600 text-xs" /> Active API Gateway:
            </span>
          </div>

          {/* Segmented Provider Switcher */}
          <div className="flex items-center bg-slate-200/90 p-0.5 rounded-md border border-slate-300">
            {/* Rapiwha Option */}
            <button
              type="button"
              onClick={() => setSelectedProvider("rapiwha")}
              className={`px-2.5 py-1 rounded text-[11px] font-bold transition flex items-center gap-1.5 cursor-pointer ${
                selectedProvider === "rapiwha"
                  ? "bg-white text-emerald-800 shadow-xs border border-slate-300/60"
                  : "text-slate-600 hover:text-slate-900"
              }`}
            >
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
              <span>Rapiwha API</span>
              <span className="text-[9px] font-semibold bg-emerald-100 text-emerald-700 px-1 py-0.2 rounded">
                Active / Standard
              </span>
            </button>

            {/* GreenAds (Telinfy Hub) Option */}
            <button
              type="button"
              onClick={() => setSelectedProvider("greenads")}
              className={`px-2.5 py-1 rounded text-[11px] font-bold transition flex items-center gap-1.5 cursor-pointer ${
                selectedProvider === "greenads"
                  ? "bg-white text-blue-800 shadow-xs border border-slate-300/60"
                  : "text-slate-600 hover:text-slate-900"
              }`}
            >
              <span className="w-1.5 h-1.5 rounded-full bg-blue-500" />
              <span>GreenAds Global (Telinfy Hub)</span>
              <span className="text-[8px] font-bold bg-amber-100 text-amber-800 border border-amber-300 px-1.5 py-0.2 rounded-full uppercase tracking-tight">
                Official Meta API • Coming Soon
              </span>
            </button>
          </div>
        </section>

        {/* ── 4. Main Body: Split Two-Column Console ── */}
        <div className="flex-1 min-h-0 flex flex-col lg:flex-row overflow-hidden bg-slate-100/50">
          {/* ════════ LEFT COLUMN: CONFIGURATION & TEMPLATE BUILDER ════════ */}
          <div className="w-full lg:w-[57%] border-r border-slate-200 bg-white flex flex-col overflow-y-auto p-2.5 sm:p-3 space-y-2 min-h-0">
            {/* Voucher Event Selector & Creator */}
            <div className="bg-slate-50 border border-slate-200 rounded-md p-2 flex flex-wrap items-center justify-between gap-2 shrink-0">
              <label className="text-xs font-bold text-slate-700 flex items-center gap-1.5 shrink-0">
                <FiFileText className="text-blue-600 text-xs" />
                <span>Voucher Event / Type:</span>
              </label>

              <div className="flex items-center gap-1.5 flex-1 justify-end min-w-[270px]">
                <div className="relative flex-1">
                  <input
                    id="entry-name-input"
                    type="text"
                    list="whatsapp-voucher-suggestions"
                    value={WhatsAppsettingsData.EntryName}
                    onChange={(e) => {
                      const val = e.target.value.toUpperCase();
                      setWhatsAppsettingsData((prev) => ({
                        ...prev,
                        EntryName: val,
                      }));
                      if (allVoucherSuggestions.includes(val)) {
                        fetchWhatsAppsettings(val);
                      }
                    }}
                    onBlur={() => {
                      const trimmed = WhatsAppsettingsData.EntryName?.trim();
                      if (trimmed) {
                        fetchWhatsAppsettings(trimmed);
                      }
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        const trimmed = WhatsAppsettingsData.EntryName?.trim();
                        if (trimmed) {
                          fetchWhatsAppsettings(trimmed);
                        }
                      }
                    }}
                    placeholder="e.g. SCHEME RECEIPT or type new..."
                    className="w-full h-7 px-2 text-xs font-bold text-slate-800 bg-white border border-slate-300 rounded focus:border-blue-500 outline-none uppercase placeholder:normal-case placeholder:font-normal placeholder:text-slate-400 placeholder:italic shadow-xs"
                  />
                  <datalist id="whatsapp-voucher-suggestions">
                    {allVoucherSuggestions.map((v) => (
                      <option key={v} value={v} />
                    ))}
                  </datalist>
                </div>

                <button
                  type="button"
                  onClick={handleCreateNewVoucher}
                  title="Create a new voucher / template type"
                  className="h-7 px-2 bg-blue-600 hover:bg-blue-700 text-white text-[11px] font-bold rounded flex items-center gap-1 transition cursor-pointer shadow-xs shrink-0"
                >
                  <FiPlus className="text-xs" />
                  <span>New Voucher</span>
                </button>

                <button
                  type="button"
                  onClick={() =>
                    fetchWhatsAppsettings(WhatsAppsettingsData.EntryName)
                  }
                  title="Reload settings from database"
                  className="h-7 px-2 bg-slate-100 hover:bg-slate-200 text-slate-700 text-xs font-medium rounded border border-slate-300 flex items-center gap-1 transition cursor-pointer shrink-0"
                >
                  <FiRefreshCw className="text-xs" />
                  <span className="hidden sm:inline">Reload</span>
                </button>
              </div>
            </div>

            {/* Provider Credentials Card */}
            {selectedProvider === "rapiwha" ? (
              /* ── RAPIWHA CREDENTIALS CARD ── */
              <div className="bg-emerald-50/40 border border-emerald-200 rounded-md p-2 space-y-2 shrink-0">
                <div className="flex items-center justify-between border-b border-emerald-200/80 pb-1">
                  <div className="flex items-center gap-1.5">
                    <FaWhatsapp className="text-emerald-600 text-xs" />
                    <span className="text-[11px] font-bold text-emerald-950 uppercase tracking-wide">
                      Rapiwha API Credentials
                    </span>
                  </div>
                  <span className="text-[9px] font-semibold text-emerald-800 bg-emerald-100 px-1.5 py-0.2 rounded">
                    panel.rapiwha.com
                  </span>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
                  {/* App Key */}
                  <div className="sm:col-span-2">
                    <label className="text-[10px] font-bold text-slate-700 block mb-0.5">
                      App Key (API Key) <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="e.g. 7A6B5C4D3E2F1G0H (API Key)"
                      value={WhatsAppsettingsData.appkey}
                      onChange={(e) =>
                        setWhatsAppsettingsData({
                          ...WhatsAppsettingsData,
                          appkey: e.target.value,
                        })
                      }
                      className="w-full h-7 px-2 text-xs text-slate-800 bg-white border border-slate-300 rounded focus:border-emerald-500 outline-none placeholder:text-slate-400 placeholder:italic"
                    />
                  </div>

                  {/* Sender Number */}
                  <div>
                    <label className="text-[10px] font-bold text-slate-700 block mb-0.5">
                      Sender Mobile No
                    </label>
                    <input
                      type="text"
                      placeholder="e.g. 919800000000"
                      value={WhatsAppsettingsData.senderNo}
                      onChange={(e) =>
                        setWhatsAppsettingsData({
                          ...WhatsAppsettingsData,
                          senderNo: e.target.value.replace(/\D/g, ""),
                        })
                      }
                      className="w-full h-7 px-2 text-xs text-slate-800 bg-white border border-slate-300 rounded focus:border-emerald-500 outline-none placeholder:text-slate-400 placeholder:italic"
                    />
                  </div>

                  {/* Auth Key (Optional) */}
                  <div className="sm:col-span-3">
                    <label className="text-[10px] font-bold text-slate-700 block mb-0.5">
                      Auth Key (Optional secret / session token)
                    </label>
                    <input
                      type="text"
                      placeholder="e.g. auth_secret_token (optional)"
                      value={WhatsAppsettingsData.authkey}
                      onChange={(e) =>
                        setWhatsAppsettingsData({
                          ...WhatsAppsettingsData,
                          authkey: e.target.value,
                        })
                      }
                      className="w-full h-7 px-2 text-xs text-slate-800 bg-white border border-slate-300 rounded focus:border-emerald-500 outline-none placeholder:text-slate-400 placeholder:italic"
                    />
                  </div>
                </div>
              </div>
            ) : (
              /* ── GREENADS (TELINFY HUB) CREDENTIALS CARD ── */
              <div className="bg-blue-50/50 border border-blue-200 rounded-md p-2 space-y-2 shrink-0">
                <div className="flex items-center justify-between border-b border-blue-200/80 pb-1">
                  <div className="flex items-center gap-1.5">
                    <FiShield className="text-blue-600 text-xs" />
                    <span className="text-[11px] font-bold text-blue-950 uppercase tracking-wide">
                      GreenAds Global (Telinfy Hub API)
                    </span>
                  </div>
                  <span className="text-[9px] font-bold text-blue-800 bg-blue-100 px-1.5 py-0.2 rounded border border-blue-200">
                    hub.telinfy.com/unified/developer/api/v1
                  </span>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                  {/* x-api-key */}
                  <div className="sm:col-span-2">
                    <label className="text-[10px] font-bold text-slate-700 block mb-0.5">
                      Developer API Key (<code className="text-blue-700">x-api-key</code>) <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="e.g. telinfy_live_api_key_xxxxxxxx"
                      value={greenAdsConfig.apiKey}
                      onChange={(e) =>
                        setGreenAdsConfig({
                          ...greenAdsConfig,
                          apiKey: e.target.value,
                        })
                      }
                      className="w-full h-7 px-2 text-xs text-slate-800 bg-white border border-slate-300 rounded focus:border-blue-500 outline-none placeholder:text-slate-400 placeholder:italic"
                    />
                  </div>

                  {/* Template Name */}
                  <div>
                    <label className="text-[10px] font-bold text-slate-700 block mb-0.5">
                      Meta Template Name <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="e.g. payment_receipt or scheme_receipt"
                      value={greenAdsConfig.templateName}
                      onChange={(e) =>
                        setGreenAdsConfig({
                          ...greenAdsConfig,
                          templateName: e.target.value,
                        })
                      }
                      className="w-full h-7 px-2 text-xs text-slate-800 bg-white border border-slate-300 rounded focus:border-blue-500 outline-none placeholder:text-slate-400 placeholder:italic"
                    />
                  </div>

                  {/* Language Code & Filename */}
                  <div className="grid grid-cols-2 gap-1.5">
                    <div>
                      <label className="text-[10px] font-bold text-slate-700 block mb-0.5">
                        Language
                      </label>
                      <input
                        type="text"
                        placeholder="e.g. en"
                        value={greenAdsConfig.language}
                        onChange={(e) =>
                          setGreenAdsConfig({
                            ...greenAdsConfig,
                            language: e.target.value,
                          })
                        }
                        className="w-full h-7 px-2 text-xs text-slate-800 bg-white border border-slate-300 rounded focus:border-blue-500 outline-none placeholder:text-slate-400 placeholder:italic"
                      />
                    </div>
                    <div>
                      <label className="text-[10px] font-bold text-slate-700 block mb-0.5">
                        PDF Filename
                      </label>
                      <input
                        type="text"
                        placeholder="e.g. Invoice.pdf"
                        value={greenAdsConfig.documentFilename}
                        onChange={(e) =>
                          setGreenAdsConfig({
                            ...greenAdsConfig,
                            documentFilename: e.target.value,
                          })
                        }
                        className="w-full h-7 px-2 text-xs text-slate-800 bg-white border border-slate-300 rounded focus:border-blue-500 outline-none placeholder:text-slate-400 placeholder:italic"
                      />
                    </div>
                  </div>

                  {/* Parameter Mapping Info Pill */}
                  <div className="sm:col-span-2 bg-white/90 border border-blue-200 rounded p-1.5 text-[10px] text-slate-700 space-y-1">
                    <span className="font-bold text-blue-900 block">
                      Body Parameter Component Mapping ({"{{1}}"} to {"{{5}}"}):
                    </span>
                    <div className="grid grid-cols-2 sm:grid-cols-5 gap-1 text-[9px]">
                      <div className="bg-slate-50 border border-slate-200 p-1 rounded">
                        <span className="font-bold text-blue-700 block">{"{{1}}"} Name</span>
                        <span className="text-slate-600 truncate block">{greenAdsConfig.param1}</span>
                      </div>
                      <div className="bg-slate-50 border border-slate-200 p-1 rounded">
                        <span className="font-bold text-blue-700 block">{"{{2}}"} Amount</span>
                        <span className="text-slate-600 truncate block">{greenAdsConfig.param2}</span>
                      </div>
                      <div className="bg-slate-50 border border-slate-200 p-1 rounded">
                        <span className="font-bold text-blue-700 block">{"{{3}}"} Op Bal</span>
                        <span className="text-slate-600 truncate block">{greenAdsConfig.param3}</span>
                      </div>
                      <div className="bg-slate-50 border border-slate-200 p-1 rounded">
                        <span className="font-bold text-blue-700 block">{"{{4}}"} Total</span>
                        <span className="text-slate-600 truncate block">{greenAdsConfig.param4}</span>
                      </div>
                      <div className="bg-slate-50 border border-slate-200 p-1 rounded">
                        <span className="font-bold text-blue-700 block">{"{{5}}"} Company</span>
                        <span className="text-slate-600 truncate block">{greenAdsConfig.param5}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Dynamic Token Insert Chips (Available for all providers) */}
            <div className="space-y-1 shrink-0">
              <div className="flex items-center justify-between">
                <label className="text-[11px] font-bold text-slate-700 flex items-center gap-1">
                  <FiSliders className="text-blue-600 text-xs" /> Dynamic Variables:
                </label>
                <span className="text-[9px] text-slate-400">Click to insert at cursor</span>
              </div>
              <div className="flex flex-wrap gap-1">
                {VARIABLES.map((v) => (
                  <button
                    key={v.key}
                    type="button"
                    onClick={() => handleInsertToken(v.key)}
                    className={`px-1.5 py-0.5 rounded text-[10px] font-semibold border transition cursor-pointer flex items-center gap-0.5 shadow-2xs ${v.btnBg}`}
                  >
                    <span>+</span>
                    <span>{v.label}</span>
                  </button>
                ))}
              </div>
            </div>

            {/* Template Message Body Editor (Available for both Rapiwha & GreenAds) */}
            <div className="space-y-1 flex-1 min-h-[95px] flex flex-col">
              <div className="flex items-center justify-between">
                <label className="text-[11px] font-bold text-slate-700 flex items-center gap-1.5">
                  <FiFileText className="text-blue-600 text-xs" />
                  <span>Template Message Body:</span>
                  {selectedProvider === "greenads" ? (
                    <span className="text-[9px] font-semibold text-blue-700 bg-blue-50 border border-blue-200 px-1.5 py-0.2 rounded">
                      Meta Template Text &amp; Preview
                    </span>
                  ) : (
                    <span className="text-[9px] font-semibold text-emerald-700 bg-emerald-50 border border-emerald-200 px-1.5 py-0.2 rounded">
                      Rapiwha Text Body
                    </span>
                  )}
                </label>
                <span className="text-[9px] text-slate-400">
                  {(selectedProvider === "greenads"
                    ? greenAdsConfig.message?.length
                    : WhatsAppsettingsData.Message?.length) || 0}{" "}
                  characters
                </span>
              </div>

              <textarea
                ref={textareaRef}
                value={
                  selectedProvider === "greenads"
                    ? greenAdsConfig.message || ""
                    : WhatsAppsettingsData.Message || ""
                }
                onChange={(e) => {
                  const val = e.target.value;
                  if (selectedProvider === "greenads") {
                    setGreenAdsConfig((prev) => ({ ...prev, message: val }));
                  } else {
                    setWhatsAppsettingsData((prev) => ({
                      ...prev,
                      Message: val,
                    }));
                  }
                }}
                placeholder={
                  selectedProvider === "greenads"
                    ? "e.g. Dear ${customerName}, your payment of ₹${total} towards Scheme A/C ${accountNo} has been received. Thank you! - ${showroomName}"
                    : "e.g. Dear ${customerName}, your payment of ₹${total} towards Scheme A/C ${accountNo} has been received. Thank you! - ${showroomName}"
                }
                className="w-full flex-1 p-2 text-xs text-slate-800 bg-white border border-slate-300 rounded focus:border-blue-500 outline-none resize-none leading-relaxed min-h-[75px] placeholder:text-slate-400 placeholder:italic"
              />
            </div>

            {/* Media Attachment Card (Header Document) */}
            <div className="bg-slate-50 border border-slate-200 rounded-md p-2 space-y-1.5 shrink-0">
              <div className="flex items-center justify-between">
                <label className="text-[11px] font-bold text-slate-700 flex items-center gap-1">
                  <FiPaperclip className="text-blue-600 text-xs" /> Attach Document / Media (PDF or Image):
                </label>
                {WhatsAppsettingsData.Media && (
                  <button
                    type="button"
                    onClick={() => {
                      setWhatsAppsettingsData((prev) => ({ ...prev, Media: null }));
                      if (fileInputRef.current) fileInputRef.current.value = "";
                    }}
                    className="text-[10px] text-red-600 hover:text-red-700 font-semibold cursor-pointer"
                  >
                    Remove Attachment
                  </button>
                )}
              </div>

              <div className="flex items-center gap-2">
                <input
                  ref={fileInputRef}
                  type="file"
                  accept=".pdf,image/png,image/jpeg,image/webp"
                  onChange={(e) =>
                    setWhatsAppsettingsData({
                      ...WhatsAppsettingsData,
                      Media: e.target.files[0] || null,
                    })
                  }
                  className="block w-full text-[11px] text-slate-600 file:mr-2.5 file:py-1 file:px-2.5 file:rounded file:border-0 file:text-[10px] file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100 cursor-pointer"
                />
              </div>

              {WhatsAppsettingsData.Media && (
                <div className="flex items-center gap-2 bg-emerald-50 border border-emerald-200 px-2 py-1 rounded text-[11px] text-emerald-900">
                  <FaFilePdf className="text-red-500 text-xs shrink-0" />
                  <span className="font-semibold truncate">
                    {WhatsAppsettingsData.Media.name}
                  </span>
                  <span className="text-[9px] text-emerald-700 shrink-0">
                    ({(WhatsAppsettingsData.Media.size / 1024).toFixed(1)} KB)
                  </span>
                  <span className="ml-auto text-[9px] bg-emerald-200 text-emerald-800 font-bold px-1 rounded">
                    Attached
                  </span>
                </div>
              )}
            </div>
          </div>

          {/* ════════ RIGHT COLUMN: SIMULATOR & RECIPIENTS CONSOLE ════════ */}
          <div className="w-full lg:w-[43%] flex flex-col bg-slate-50 border-t lg:border-t-0 overflow-hidden min-h-0">
            {/* Console Tab Switcher */}
            <div className="bg-white border-b border-slate-200 px-2.5 py-1.5 flex items-center justify-between shrink-0">
              <div className="flex items-center space-x-1">
                <button
                  type="button"
                  onClick={() => setActiveRightTab("preview")}
                  className={`px-2.5 py-1 rounded text-[11px] font-bold transition flex items-center gap-1 cursor-pointer ${
                    activeRightTab === "preview"
                      ? "bg-emerald-50 text-emerald-700 border border-emerald-200"
                      : "text-slate-600 hover:text-slate-900"
                  }`}
                >
                  <FaWhatsapp className="text-xs" />
                  <span>Live Chat Preview</span>
                </button>

                <button
                  type="button"
                  onClick={() => setActiveRightTab("recipients")}
                  className={`px-2.5 py-1 rounded text-[11px] font-bold transition flex items-center gap-1 cursor-pointer ${
                    activeRightTab === "recipients"
                      ? "bg-blue-50 text-blue-700 border border-blue-200"
                      : "text-slate-600 hover:text-slate-900"
                  }`}
                >
                  <FiUser className="text-xs" />
                  <span>Recipients List ({tableData.length})</span>
                </button>
              </div>

              {activeRightTab === "preview" ? (
                /* Mock Customer Switcher */
                <div className="flex items-center space-x-1 text-[10px]">
                  <span className="text-slate-400 font-medium">Demo:</span>
                  {SAMPLE_MOCKS.map((m, idx) => (
                    <button
                      key={m.name}
                      type="button"
                      onClick={() => setMockIndex(idx)}
                      className={`px-1.5 py-0.5 rounded text-[9px] font-semibold transition cursor-pointer ${
                        mockIndex === idx
                          ? "bg-slate-800 text-white"
                          : "bg-slate-200 text-slate-700 hover:bg-slate-300"
                      }`}
                    >
                      {m.name}
                    </button>
                  ))}
                </div>
              ) : (
                /* Action Controls for Recipients List */
                <div className="flex items-center space-x-1">
                  <button
                    type="button"
                    onClick={fetchNumbers}
                    title="Reload contacts from database"
                    className="px-1.5 py-0.5 text-[9px] font-semibold text-slate-700 hover:text-slate-900 hover:bg-slate-100 rounded border border-slate-300 transition flex items-center gap-0.5 cursor-pointer"
                  >
                    <FiRefreshCw className="text-[10px]" />
                    <span>Reload DB</span>
                  </button>
                  <button
                    type="button"
                    onClick={() => removeRow()}
                    title="Remove all recipient numbers"
                    className="px-1.5 py-0.5 text-[9px] font-bold text-red-600 hover:text-red-800 hover:bg-red-50 rounded border border-red-200 transition flex items-center gap-0.5 cursor-pointer"
                  >
                    <FiTrash2 className="text-[10px]" />
                    <span>Clear</span>
                  </button>
                </div>
              )}
            </div>

            {/* Console Content */}
            <div className="flex-1 min-h-0 overflow-y-auto p-2 sm:p-2.5 flex flex-col">
              {activeRightTab === "preview" ? (
                /* ── TAB 1: AUTHENTIC LIVE WHATSAPP SIMULATOR ── */
                <div className="flex-1 min-h-0 flex flex-col justify-center items-center">
                  <div className="w-full max-w-[340px] bg-[#efeae2] rounded-xl shadow-xs border border-slate-300 overflow-hidden flex flex-col my-auto max-h-[420px]">
                    {/* WhatsApp Chat Header */}
                    <div className="bg-[#075e54] text-white px-2.5 py-2 flex items-center justify-between shadow-xs shrink-0">
                      <div className="flex items-center space-x-2">
                        <div className="w-7 h-7 rounded-full bg-emerald-700 border border-emerald-400 flex items-center justify-center font-bold text-amber-300 text-[10px]">
                          WA
                        </div>
                        <div>
                          <div className="flex items-center space-x-1">
                            <span className="text-[11px] font-bold tracking-tight">
                              {activeLocation?.LocationName || "Business Account"}
                            </span>
                            <span className="w-3 h-3 rounded-full bg-emerald-400 flex items-center justify-center text-[7px] text-emerald-950 font-black">
                              ✓
                            </span>
                          </div>
                          <span className="text-[9px] text-emerald-100/90 block leading-tight">
                            Official Business Account • Online
                          </span>
                        </div>
                      </div>
                      <span className="text-[9px] font-bold text-emerald-200 bg-emerald-800/80 px-1 py-0.2 rounded">
                        {selectedProvider === "greenads" ? "Meta Cloud" : "Standard"}
                      </span>
                    </div>

                    {/* Chat Messages Canvas */}
                    <div className="flex-1 p-2.5 flex flex-col justify-end space-y-1.5 overflow-y-auto bg-[radial-gradient(#d3cbbd_1px,transparent_1px)] [background-size:16px_16px]">
                      {/* Security Encryption Pill */}
                      <div className="self-center bg-[#ffeecd] border border-[#f3d99e] text-slate-800 text-[8px] font-medium px-1.5 py-0.5 rounded shadow-2xs text-center max-w-[95%]">
                        🔒 Official verified WhatsApp business notification.
                      </div>

                      {/* WhatsApp Outgoing Speech Bubble */}
                      <div className="self-end max-w-[92%] bg-[#d9fdd3] text-slate-900 rounded-lg rounded-tr-xs p-2 shadow-2xs border border-[#c3f2ba] space-y-1.5">
                        {/* Header Media / PDF Preview */}
                        {WhatsAppsettingsData.Media && (
                          <div className="bg-white/80 border border-emerald-200 rounded p-1.5 flex items-center space-x-2">
                            <div className="w-6 h-7 rounded bg-red-100 flex items-center justify-center text-red-600 shrink-0">
                              <FaFilePdf className="text-sm" />
                            </div>
                            <div className="overflow-hidden">
                              <span className="text-[10px] font-bold text-slate-800 block truncate">
                                {greenAdsConfig.documentFilename ||
                                  WhatsAppsettingsData.Media.name}
                              </span>
                              <span className="text-[8px] text-slate-500 block">
                                PDF Document •{" "}
                                {(WhatsAppsettingsData.Media.size / 1024).toFixed(1)} KB
                              </span>
                            </div>
                          </div>
                        )}

                        {/* Rendered Text Message */}
                        <p className="text-[11px] text-slate-800 whitespace-pre-wrap leading-relaxed">
                          {activeSimulatorMessage}
                        </p>

                        {/* WhatsApp Message Metadata: Time & Double Ticks */}
                        <div className="flex items-center justify-end space-x-1 text-[8px] text-slate-500 pt-0.5">
                          <span>
                            {new Date().toLocaleTimeString("en-IN", {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            })}
                          </span>
                          <FaCheckDouble className="text-blue-500 text-[9px]" />
                        </div>
                      </div>
                    </div>

                    {/* Chat Simulator Footer Bar */}
                    <div className="bg-slate-200 px-2 py-1 text-center text-[9px] text-slate-600 border-t border-slate-300 shrink-0">
                      Simulated preview for <strong>{activeMockData.customerName}</strong> ({activeMockData.mobileNo})
                    </div>
                  </div>
                </div>
              ) : (
                /* ── TAB 2: RECIPIENT TABLE & CONTACTS MANAGER ── */
                <div className="flex-1 min-h-0 flex flex-col space-y-1.5">
                  {/* Search and Filter */}
                  <div className="relative shrink-0">
                    <FiSearch className="absolute left-2.5 top-2 text-slate-400 text-xs" />
                    <input
                      type="text"
                      placeholder="Search recipient by name or phone..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      className="w-full h-7 pl-7 pr-3 text-xs text-slate-800 bg-white border border-slate-300 rounded focus:border-blue-500 outline-none"
                    />
                  </div>

                  {/* Add Recipient Inline Form */}
                  <div className="bg-white border border-slate-300 rounded p-1 flex items-center gap-1 shadow-2xs shrink-0">
                    <input
                      type="text"
                      placeholder="e.g. Customer Name"
                      value={newRow.CustomerName}
                      onChange={(e) =>
                        setNewRow({ ...newRow, CustomerName: e.target.value })
                      }
                      className="flex-1 h-6 px-1.5 text-xs text-slate-800 bg-slate-50 border border-slate-200 rounded focus:border-blue-500 outline-none placeholder:text-slate-400 placeholder:italic"
                    />
                    <input
                      type="text"
                      placeholder="e.g. 919800000000"
                      value={newRow.mobileNo}
                      onChange={(e) =>
                        setNewRow({
                          ...newRow,
                          mobileNo: e.target.value.replace(/\D/g, ""),
                        })
                      }
                      className="w-28 h-6 px-1.5 text-xs text-slate-800 bg-slate-50 border border-slate-200 rounded focus:border-blue-500 outline-none placeholder:text-slate-400 placeholder:italic"
                    />
                    <button
                      type="button"
                      onClick={addRow}
                      className="h-6 px-2 bg-emerald-600 hover:bg-emerald-700 text-white text-xs font-bold rounded flex items-center gap-0.5 transition cursor-pointer"
                    >
                      <FiPlus />
                      <span>Add</span>
                    </button>
                  </div>

                  {/* Recipients Table */}
                  <div
                    ref={tableContainerRef}
                    onScroll={handleScroll}
                    onKeyDown={handleTableKeyDown}
                    tabIndex={0}
                    className="flex-1 min-h-0 bg-white border border-slate-300 rounded overflow-y-auto outline-none select-none"
                  >
                    {isLoading ? (
                      <div className="flex flex-col items-center justify-center h-36 space-y-1.5 text-slate-500">
                        <ClipLoader color="#0f2d59" size={20} />
                        <span className="text-[11px]">Loading test contacts...</span>
                      </div>
                    ) : filteredRecipients.length === 0 ? (
                      <div className="flex flex-col items-center justify-center h-36 text-slate-400 text-xs italic">
                        No contacts available. Click &quot;Reset Dummy&quot; or add a contact above.
                      </div>
                    ) : (
                      <table className="w-full text-left text-xs border-collapse">
                        <thead className="bg-[#0f2d59] text-white sticky top-0 z-10 text-[10px]">
                          <tr>
                            <th className="py-1 px-2 font-semibold">Contact Name</th>
                            <th className="py-1 px-2 font-semibold">Mobile Number</th>
                            <th className="py-1 px-1.5 font-semibold text-center w-14">
                              Actions
                            </th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-200">
                          {displayedRecipients.map((row, idx) => (
                            <tr
                              key={idx}
                              className="hover:bg-blue-50/60 transition-colors"
                            >
                              <td className="py-1 px-2 font-medium text-slate-800 truncate max-w-[130px]">
                                {row.CustomerName || "Contact"}
                              </td>
                              <td className="py-1 px-2 text-slate-600 font-Inter text-[11px]">
                                {row.mobileNo}
                              </td>
                              <td className="py-1 px-1 text-center flex items-center justify-center gap-1">
                                <button
                                  type="button"
                                  onClick={() => handleSend(row)}
                                  title="Send test message to this contact"
                                  className="w-5 h-5 rounded hover:bg-emerald-100 text-emerald-600 flex items-center justify-center transition cursor-pointer"
                                >
                                  <FiSend className="text-[10px]" />
                                </button>
                                <button
                                  type="button"
                                  onClick={() => removeRow(row)}
                                  title="Delete contact"
                                  className="w-5 h-5 rounded hover:bg-red-100 text-red-600 flex items-center justify-center transition cursor-pointer"
                                >
                                  <FiTrash2 className="text-[10px]" />
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>

                  {/* Continuous Scroll Status Bar */}
                  <div className="flex items-center justify-between px-2 py-1 bg-slate-50 border border-t-0 border-slate-300 rounded-b text-[10px] text-slate-500 font-Inter shrink-0">
                    <span>
                      Showing{" "}
                      <strong className="text-slate-800 font-semibold">
                        {Math.min(visibleCount, filteredRecipients.length)}
                      </strong>{" "}
                      of{" "}
                      <strong className="text-blue-700 font-semibold">
                        {filteredRecipients.length}
                      </strong>{" "}
                      contacts
                    </span>
                    {hasMore && (
                      <button
                        type="button"
                        onClick={loadAll}
                        className="text-blue-600 hover:text-blue-800 font-semibold text-[9px] underline cursor-pointer"
                      >
                        Load all
                      </button>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* ── 5. Action Footer ── */}
        <footer className="bg-white px-3 py-1.5 border-t border-slate-200 flex flex-wrap items-center justify-between gap-1.5 shrink-0 h-10">
          {/* Left Keyboard Hints */}
          <div className="flex items-center space-x-1.5 text-[10px] text-slate-500">
            <span className="font-semibold text-slate-700">Shortcuts:</span>
            <kbd className="px-1 py-0.2 bg-slate-100 border border-slate-300 rounded text-slate-600 text-[9px] font-Inter font-semibold">
              F2
            </kbd>
            <span>Save</span>
            <span>•</span>
            <kbd className="px-1 py-0.2 bg-slate-100 border border-slate-300 rounded text-slate-600 text-[9px] font-Inter font-semibold">
              Esc
            </kbd>
            <span>Exit</span>
          </div>

          {/* Right Action Buttons */}
          <div className="flex items-center space-x-1.5">
            {/* Clear Button */}
            <button
              type="button"
              onClick={handleClear}
              className="h-7 px-2.5 text-xs font-semibold text-slate-700 bg-slate-100 hover:bg-slate-200 border border-slate-300 rounded transition cursor-pointer"
            >
              Clear
            </button>

            {/* Test Send / Broadcast All */}
            <button
              type="button"
              onClick={() => handleSend()}
              disabled={sendProgress.sending}
              className="h-7 px-3 text-xs font-bold text-white bg-emerald-600 hover:bg-emerald-700 active:scale-98 disabled:opacity-50 rounded transition flex items-center gap-1 shadow-2xs cursor-pointer"
            >
              <FiSend className="text-xs" />
              <span>
                Broadcast to {tableData.length > 0 ? tableData.length : "Contacts"}
              </span>
            </button>

            {/* Save Settings Button */}
            <button
              type="button"
              onClick={handleSave}
              disabled={isSaving}
              className="h-7 px-3.5 text-xs font-bold text-white bg-blue-600 hover:bg-blue-700 active:scale-98 disabled:opacity-50 rounded transition flex items-center gap-1 shadow-2xs cursor-pointer"
            >
              <FiSave className="text-xs" />
              <span>{isSaving ? "Saving..." : "Save Settings (F2)"}</span>
            </button>

            {/* Close Button */}
            <button
              type="button"
              onClick={onClose}
              className="h-7 px-3 text-xs font-semibold text-slate-700 bg-slate-100 hover:bg-slate-200 border border-slate-300 rounded transition cursor-pointer"
            >
              Close
            </button>
          </div>
        </footer>

        {/* ── 6. Live Send Progress Modal Overlay ── */}
        {sendProgress.sending && (
          <div className="absolute inset-0 bg-slate-900/60 backdrop-blur-xs flex items-center justify-center z-50 p-3">
            <div className="bg-white rounded-lg shadow-2xl border border-slate-200 p-5 flex flex-col items-center gap-2.5 w-80 max-w-full">
              <ClipLoader color="#059669" size={32} />

              <div className="text-center">
                <h3 className="text-xs font-bold text-slate-900">
                  Dispatching WhatsApp Messages
                </h3>
                <span className="text-[10px] text-slate-500 font-medium block mt-0.5">
                  Sending via{" "}
                  {selectedProvider === "greenads" ? "GreenAds Telinfy" : "Rapiwha"}
                </span>
              </div>

              {/* Progress Count */}
              <p className="text-xs font-bold text-emerald-700">
                {sendProgress.sent} of {sendProgress.total} Dispatched
              </p>

              {/* Progress Bar */}
              <div className="w-full bg-slate-200 rounded-full h-2 overflow-hidden">
                <div
                  className="bg-emerald-500 h-full transition-all duration-300 rounded-full"
                  style={{
                    width: `${
                      sendProgress.total > 0
                        ? (sendProgress.sent / sendProgress.total) * 100
                        : 0
                    }%`,
                  }}
                />
              </div>

              {/* Current Recipient indicator */}
              {sendProgress.currentName && (
                <span className="text-[10px] text-slate-500 truncate max-w-[220px]">
                  Current: {sendProgress.currentName}
                </span>
              )}

              {/* Cancel Button */}
              <button
                type="button"
                onClick={handleCancelSend}
                className="mt-1 px-3 py-1 bg-red-600 hover:bg-red-700 text-white rounded text-xs font-bold transition cursor-pointer"
              >
                Cancel Sending
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default WhatsAppSettings;
